import React, {Component, Fragment} from 'react';

import connect from "react-redux/es/connect/connect";
import GlobalPopup from "./GlobalPopup";
import { withRouter } from 'react-router-dom';

class PopupContainer extends Component {
  render() {
    const { props } = this;
    const { popupState } = props;
    if(process.env.REACT_APP_DISABLE_TUTORIALS === 'true') return null;

    return (
      <Fragment>
        { popupState.popupId ? (
          <GlobalPopup/>
        ) : null }
      </Fragment>
    )
  }
}

export default withRouter(connect(state => state)(PopupContainer));



// WEBPACK FOOTER //
// ./src/components/elements/PopupContainer.js